/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appVersionApiV2AppVersionGet } from '../fn/operations/app-version-api-v-2-app-version-get';
import { AppVersionApiV2AppVersionGet$Params } from '../fn/operations/app-version-api-v-2-app-version-get';

@Injectable({ providedIn: 'root' })
export class ApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appVersionApiV2AppVersionGet()` */
  static readonly AppVersionApiV2AppVersionGetPath = '/api/v2/app-version';

  /**
   * App Version.
   *
   * Returns the app version of the app
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appVersionApiV2AppVersionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  appVersionApiV2AppVersionGet$Response(params?: AppVersionApiV2AppVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return appVersionApiV2AppVersionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * App Version.
   *
   * Returns the app version of the app
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appVersionApiV2AppVersionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appVersionApiV2AppVersionGet(params?: AppVersionApiV2AppVersionGet$Params, context?: HttpContext): Observable<any> {
    return this.appVersionApiV2AppVersionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
